import styled from 'styled-components';
import {
  color,
  ColorProps,
  space,
  SpaceProps,
  FontSizeProps,
  typography,
  flexbox,
  FlexboxProps,
  TypographyProps,
  compose
} from 'styled-system';

/**
 * Components.
 */
import Typography from '../../commonComponents/Typography/Typography';
import Grid, { IGridProps } from '../../layoutComponents/Grid';
import { colorLuminance } from '../../../utils/colors';

/**
 * Types.
 */
type StyledLabelProps = FlexboxProps & { isCheckboxOrRadio?: boolean };
type RequiredStarProps = ColorProps & SpaceProps & TypographyProps;
export type StyledItemProps = SpaceProps & FontSizeProps;

/**
 * Label for form element.
 */
export const StyledLabel = styled(Typography)<StyledLabelProps>`
  ${compose(flexbox, typography)};
  cursor: ${({ isCheckboxOrRadio }) =>
    isCheckboxOrRadio ? 'pointer' : 'default'};
  padding-left: ${({ isCheckboxOrRadio, theme }) =>
    isCheckboxOrRadio ? theme.space[2] : theme.space[0]}px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover ~ input:checked:not(:disabled) ~ div {
    background-color: ${({ theme }) =>
      colorLuminance(theme.colors.form.input.border.focus, 0.2)};
  }
`;

/**
 * Optional required visual indicator next to form
 * item label.
 */
export const RequiredStar = styled.span<RequiredStarProps>`
  ${compose(color, space, typography)};
`;

type IItemProps = IGridProps & { disabled?: boolean };

export const StyledItem = styled(Grid)<IItemProps>`
  ${({ theme, disabled }) => `
    padding: ${theme.space[2]}px ${theme.space[3]}px
      ${theme.space[2]}px ${theme.space[3]}px;

    ${
      disabled
        ? `
      * {
        cursor: not-allowed;
      }
    `
        : `

      * input {
        cursor: text;
      }
    `
    }
  `}
  ${space}
`;
